var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600mm",
    height: "600mm",
    viewBox: "0 0 600 600",
    id: "svg857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs854"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.55966,
    y: 485.72228,
    width: 1924.1569,
    height: 1370.2897,
    id: "rect1032"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "scale(0.26458333)",
    id: "text1030",
    style: {
      fontSize: "192.00000242px",
      fontFamily: "'Segoe UI'",
      InkscapeFontSpecification: "'Segoe UI'",
      whiteSpace: "pre",
      shapeInside: "url(#rect1032)",
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.566929,
      fontWeight: "normal",
      fontStyle: "normal",
      fontStretch: "normal",
      fontVariant: "normal"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "196.422px",
      fontFamily: "'Segoe UI'",
      InkscapeFontSpecification: "'Segoe UI'",
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.579987
    },
    x: 42.675682,
    y: 371.54825,
    id: "text1038"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1036",
    style: {
      strokeWidth: 0.579987
    },
    x: 42.675682,
    y: 371.54825
  }, "Parcel"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.d9b8ca387592c53725048831a810850f.svg";
export { ForwardRef as ReactComponent };